import { render } from "./article-cate-set.vue?vue&type=template&id=5a4eedbc&scoped=true&ts=true"
import script from "./article-cate-set.vue?vue&type=script&lang=ts"
export * from "./article-cate-set.vue?vue&type=script&lang=ts"

import "./article-cate-set.vue?vue&type=style&index=0&id=5a4eedbc&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4eedbc"]])

export default __exports__